import type { MobxDocument } from '../firestore-mobx'
import {
  empty,
  type FirestoreSlideDeckRubricAI,
} from '../firestore/SlideDeckRubricAI'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { makeObservable } from 'mobx'

export class SlideDeckRubricAI extends ObservableModelWithDecorators<FirestoreSlideDeckRubricAI> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideDeckRubricAI>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
